export { default } from './search-results-filter-chips.component';
